import { render, staticRenderFns } from "./PdfWidget.vue?vue&type=template&id=16a5646c"
import script from "./PdfWidget.vue?vue&type=script&lang=js"
export * from "./PdfWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('16a5646c')) {
      api.createRecord('16a5646c', component.options)
    } else {
      api.reload('16a5646c', component.options)
    }
    module.hot.accept("./PdfWidget.vue?vue&type=template&id=16a5646c", function () {
      api.rerender('16a5646c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/layoutDesigner/designer/widgets/PdfWidget.vue"
export default component.exports